import { useEffect } from 'react'
import Dialog from '@mui/material/Dialog'
import { DialogContent, Grid } from '@mui/material'
import ShowTimeClockText from './ShowTimeClockText'
import TimeClockMenus from './TimeClockMenus'
import { useMobileOrientation } from 'react-device-detect'
import TimeClockPopupProvider, {
    useTimeClockPopupContext,
} from './TimeClockPopupProvider'
import CloseDialogButton from 'components/Dialog/CloseDialogButton'

export interface TimeClockPopupProps {
    open: boolean
    handleClose: Function
}

const TimeClockPopupContainer = ({
    open = true,
    handleClose,
}: TimeClockPopupProps) => {
    const {
        loading,
        timeClock,
        getCurrentUserTimeClock,
    } = useTimeClockPopupContext()

    useEffect(() => {
        if (open) {
            getCurrentUserTimeClock()
        }
    }, [getCurrentUserTimeClock, open])

    const { isPortrait } = useMobileOrientation()

    return (
        <Dialog
            fullWidth={true}
            maxWidth={'md'}
            open={open}
            onClose={() => handleClose()}
        >
            <CloseDialogButton
                dialogName="time clock pop up"
                onClick={() => handleClose()}
            />
            <DialogContent sx={{ p: 0 }}>
                <Grid container height={isPortrait ? '80vh' : '60vh'}>
                    <Grid
                        item
                        container
                        xs={isPortrait ? 12 : 5}
                        sx={{
                            height: isPortrait ? '20vh' : '60vh',
                            backgroundColor: 'topside.default',
                            px: { xs: 1, sm: 4 },
                        }}
                        alignItems="center"
                        justifyContent="center"
                    >
                        <ShowTimeClockText
                            loading={loading}
                            timeClock={timeClock}
                        />
                    </Grid>

                    <Grid
                        item
                        container
                        xs={isPortrait ? 12 : 7}
                        sx={{
                            height: '60vh',
                            width: '100%',
                            overflowY: 'auto',
                            py: 1,
                        }}
                        alignItems="center"
                        justifyContent="center"
                    >
                        <TimeClockMenus />
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    )
}

function TimeClockPopup({ open = true, handleClose }: TimeClockPopupProps) {
    return (
        <TimeClockPopupProvider>
            <TimeClockPopupContainer open={open} handleClose={handleClose} />
        </TimeClockPopupProvider>
    )
}

export default TimeClockPopup
